module.exports = __webpack_public_path__ + "img/logo_title.ef052abd.png";